import { CBooking } from '../mdl/c-booking';
import { CSessionEventView } from '../mdl/c-event-admin';
import { TTicket } from '../mdl/t-ticket';
import { $api } from '../y/api';
import { $http } from '../y/http';
import { $time, YTime } from '../y/time';
import { YId, YTimeString } from '../y/types';

export class ABTicketManager {
    private _tickets: TTicket[];
    private _session: YId;
    private _scheduled: YTime | undefined;
    private _count_span?: HTMLElement;

    constructor(session: CSessionEventView, tickets: TTicket[], count_span?: HTMLElement) {
        this._tickets = tickets;
        this._session = session.id;
        this._count_span = count_span;
        this._scheduled = $time(session.tickets_scheduled);
        this._updateCount();
    }

    private _updateCount() {
        if(this._count_span)
            this._count_span.textContent = this._tickets.length ? `(${this._tickets.length})\u00a0` : '';
    }

    remove(id: YId) {
        return $http.DELETE(`/service/ticket/v1/ticket/${id}`).then(() => {
            this._tickets = this._tickets.filter(t => t.id != id);
            this._updateCount();
        }, $api.errorHandler);
    }

    assign(id: YId, booking?: YId) {
        return $http.POST(`/service/ticket/v1/ticket/${id}/assign`, { booking }).then(() => {
            const ticket = this._tickets.find(t => t.id == id);
            if(ticket)
                ticket.booking_id = booking;
        }, $api.errorHandler);
    }

    removeAll() {
        return $http.POST<TTicket[]>(`/service/ticket/v1/session/${this._session}/remove`).then(tickets => {
            this._tickets = tickets;
            this._updateCount();
        }, $api.errorHandler);
    }

    assignAll() {
        return $http.POST<TTicket[]>(`/service/ticket/v1/session/${this._session}/assign`).then(tickets => {
            this._tickets = tickets;
            this._updateCount();
        }, $api.errorHandler);
    }

    sendAll() {
        return $http.POST<CBooking[]>(`/service/ticket/v1/session/${this._session}/send`);
    }

    schedule(time?: YTime) {
        return $http.POST<TTicket[]>(`/service/ticket/v1/session/${this._session}/schedule`, { time }).then(() => {
            this._scheduled = $time(time);
        }, $api.errorHandler);
    }

    create(booking_id: YId | undefined, upload_id: YId, name: string) {
        return $http.POST<TTicket>(`/service/ticket/v1/booking_ticket`, { booking_id, upload_id, name }).then(ticket => {
            this._tickets.push(ticket);
            this._updateCount();
        }, $api.errorHandler);
    }

    forBooking(booking_id?: YId) {
        return this._tickets.filter(t => t.booking_id == booking_id);
    }

    nameForBooking(booking_id: YId) {
        const tickets = this.forBooking(booking_id);
        return tickets.length ? (tickets[0].name ?? '') : '';
    }

    set tickets(tickets: TTicket[]) {
        this._tickets = tickets;
        this._updateCount();
    }

    get scheduled(): YTime | undefined {
        return this._scheduled;
    }

    set scheduled(time: YTimeString | undefined) {
        this._scheduled = $time(time);
    }
}
